module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-header-button-group"
  }, [_vm._t("default"), _vm._v(" "), (_vm.showMore) ? _c('div', {
    staticClass: "button-group-more"
  }, [_c('el-popover', {
    ref: "popover",
    attrs: {
      "trigger": "hover",
      "popper-class": "rtElPopover"
    },
    on: {
      "show": _vm.moveBtns
    }
  }, [_c('div', {
    staticClass: "rt-button-more",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._v("...")])])], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11176158"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rtHeaderButtonGroup.vue
// module id = 1459
// module chunks = 91